export default function simpleMenu() {
  return {
    openDropdown: new Map<number, boolean>(),
    openLanguage: false,
    toggleMenuSectionOpen(key: number) {
      this.openDropdown.set(key, this.openDropdown.has(key) ? !this.openDropdown.get(key) : true);
    },
    menuSectionOpen(key: number) {
      return this.openDropdown.has(key) && this.openDropdown.get(key);
    },
    toggleLanguageOpen() {
      this.openLanguage = !this.openLanguage;
    },
    closeLanguageOpen() {
      this.openLanguage = false;
    },
  };
}
